<script setup lang="ts">
const data = inject(keys.packetVariantCard);

const primaryPrices = usePrices(() => data?.value.primary);

const secondaryPrices = usePrices(() => data?.value.secondary);

const showDisclaimer = computed(
  () =>
    [secondaryPrices, primaryPrices].every((it) => {
      const value = unref(it);
      return !value || value === "NOT_APPLICABLE";
    }),
);
</script>

<template>
  <div v-if="showDisclaimer">
    <slot name="disclaimer">
      <CardsCompanyPriceDisclaimer />
    </slot>
  </div>
  <div v-else>
    <slot />
  </div>
</template>
